import React from 'react';
import './Features.css';

const Features = () => {
  return (
    <section className="py-5 bg-light" id="features">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center mb-5">
            <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill mb-3">
              ✨ Features
            </span>
            <h2 className="display-5 fw-bold mb-4">Why Choose MastiShorts?</h2>
            <p className="lead text-muted">
              Discover the powerful features that make MastiShorts the ultimate platform for creators and entertainers.
            </p>
          </div>
        </div>
        
        <div className="row g-4">
          <div className="col-lg-4">
            <div className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden position-relative hover-lift">
              <img src="/img/block1.jpg" className="card-img-top" alt="Live Experience" style={{ height: '280px', objectFit: 'cover' }} />
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient-primary opacity-10"></div>
              <div className="card-body text-center p-4 position-relative">
                <div className="bg-primary bg-gradient text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3 shadow" style={{width: '60px', height: '60px'}}>
                  <i className="fas fa-video fa-lg"></i>
                </div>
                <h4 className="fw-bold mb-3 text-dark">Seamless Live Experience</h4>
                <p className="text-muted mb-4">
                  Go live without limits. Our lightning-fast servers and clean interface ensure a smooth and lag-free broadcast every time.
                </p>
                <button className="btn btn-primary btn-sm rounded-pill px-4 py-2 shadow-sm">
                  Read More <i className="fa fa-arrow-right ms-1"></i>
                </button>
              </div>
            </div>
          </div>
          
          <div className="col-lg-4">
            <div className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden position-relative hover-lift">
              <img src="/img/block2.jpg" className="card-img-top" alt="Creative Tools" style={{ height: '280px', objectFit: 'cover' }} />
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient-success opacity-10"></div>
              <div className="card-body text-center p-4 position-relative">
                <div className="bg-success bg-gradient text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3 shadow" style={{width: '60px', height: '60px'}}>
                  <i className="fas fa-palette fa-lg"></i>
                </div>
                <h4 className="fw-bold mb-3 text-dark">Create Without Boundaries</h4>
                <p className="text-muted mb-4">
                  From filters to soundtracks — unleash your creativity with powerful tools to make engaging short videos right on your phone.
                </p>
                <button className="btn btn-success btn-sm rounded-pill px-4 py-2 shadow-sm">
                  Read More <i className="fa fa-arrow-right ms-1"></i>
                </button>
              </div>
            </div>
          </div>
          
          <div className="col-lg-4">
            <div className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden position-relative hover-lift">
              <img src="/img/block3.jpg" className="card-img-top" alt="Community" style={{ height: '280px', objectFit: 'cover' }} />
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient-info opacity-10"></div>
              <div className="card-body text-center p-4 position-relative">
                <div className="bg-info bg-gradient text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3 shadow" style={{width: '60px', height: '60px'}}>
                  <i className="fas fa-users fa-lg"></i>
                </div>
                <h4 className="fw-bold mb-3 text-dark">Built for Real Connection</h4>
                <p className="text-muted mb-4">
                  Interact in real-time with fans, friends, and fellow creators. MastiShorts is more than an app — it's your community.
                </p>
                <button className="btn btn-info btn-sm rounded-pill px-4 py-2 shadow-sm">
                  Read More <i className="fa fa-arrow-right ms-1"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
